export default function Folder_Project_Footer() {
    return (
        <div className="post-footer">
            <div className="post-foot flex justify center">
                <div className="project-info1 flex center">
                    <div className="pinfo flex center">
                        <div className="pnotes"><i className="ti ti-info-circle"></i></div>
                    </div>
                </div>
                <div className="project-info1 flex center">
                    <div className="pinfo flex center">
                        <div className="pnotes"><i className="ti ti-device-desktop"></i></div>
                    </div>
                </div>
                <div className="project-info1 flex center">
                    <div className="pinfo flex center">
                        <div className="pnotes"><i className="ti ti-brand-github"></i></div>
                    </div>
                </div>
            </div>
        </div>
    );
}